<template>
  <ProjectScaffold :loading="loadingBrief" :authenticated="false" :metadata="false" :identity="false" :showMenu="false">
    <template #project-name>
      <p class="project-name">
        Welcome to your dedicated brief area, for <b class="">{{ currentProject.name }}</b>.
      </p>
    </template>
    <template #project-properties>
      <p class="project-properties">
        From <b class="">{{ resource.sharedBy.name }}</b> with <b>{{ projectBrandNames }}</b>
      </p>
    </template>
    <!-- <p class="title">Brief</p> -->
    <AlertInfoBox
        message="Please review the form below and provide as much information as possible so we can move forward with the production of your assets. You can save you changes anytime, and also choose to submit your brief once it’s 100% ready! "/>
    <AlertCommentBox v-if="description" :message="description"/>

    <div v-if="briefSelected === 'b1'">
      <draggable v-model="b1" :list="b1" draggable=".form-section">
        <ts-form-section :title="item.title" class="form-section" v-for="item in b1" :key="item.id">
          <div class="actions-bloc">
            <ts-button type="primary" size="small" circle class="move-button" @click="moveElement(item.id)">
              <ts-icon icon="chevron-down" size="x-small" color="#6d7587"/>
            </ts-button>
            <ts-button type="primary" size="small" circle class="move-button">
              <ts-icon icon="hand" size="x-small" color="#6d7587"/>
            </ts-button>
            <ts-button type="primary" size="small" circle class="delete-button" @click="deleteElement(item.id, 'b1')">
              <ts-icon icon="trash" size="x-small" color="#6d7587"/>
            </ts-button>
          </div>
          <ts-form-item :label="item.label" class="form-item">
            <ts-input
                :rows="6"
                type="textarea"
                v-model="formData[item.id]"
                :placeholder="item.placeholder"
                :disabled="loading"
            ></ts-input>
          </ts-form-item>
        </ts-form-section>
      </draggable>
    </div>

    <div v-if="briefSelected === 'b2'">
      <draggable v-model="b1" :list="b2" draggable=".form-section">
        <ts-form-section :title="item.title" class="form-section" v-for="item in b2" :key="item.id">
          <div class="actions-bloc">
            <ts-button type="primary" size="small" circle class="move-button" @click="moveElement(item.id)">
              <ts-icon icon="chevron-down" size="x-small" color="#6d7587"/>
            </ts-button>
            <ts-button type="primary" size="small" circle class="move-button">
              <ts-icon icon="hand" size="x-small" color="#6d7587"/>
            </ts-button>
            <ts-button type="primary" size="small" circle class="delete-button" @click="deleteElement(item.id, 'b2')">
              <ts-icon icon="trash" size="x-small" color="#6d7587"/>
            </ts-button>
          </div>
          <ts-form-item :label="item.label" class="form-item">
            <ts-input
                :rows="6"
                type="textarea"
                v-model="formData[item.id]"
                :placeholder="item.placeholder"
                :disabled="loading"
            ></ts-input>
          </ts-form-item>
        </ts-form-section>
      </draggable>
    </div>


    <div class="fixed right-0 bottom-10 flex">
      <ts-button :loading="loading" :disabled="uploading" @click="handleSubmit(false)">Save your brief</ts-button>
      <div class="pl-4">
        <ts-button filled type="primary" :loading="loading" :disabled="uploading" @click="handleSubmit(true)"
        >Save and submit your brief
        </ts-button
        >
      </div>
    </div>
  </ProjectScaffold>
</template>

<style lang="scss" scoped>
.project-properties {
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #6d7587;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;

  & b {
    font-weight: 500;
  }
}

.project-name {
  font-family: Roboto;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.7;
  letter-spacing: normal;
  color: #000;
  margin-bottom: .5rem;

  & b {
    font-weight: 500;
  }
}

.pl-4 {
  padding-left: 1rem;
}

.flex {
  display: flex;
}

.right-0 {
  right: 3rem;
}

.bottom-10 {
  bottom: 30px;
}

.fixed {
  position: absolute;
}

.flex-auto {
  flex: auto;
}

.pb-10 {
  padding-bottom: 3.25rem;
}

.mt-6 {
  margin-top: 1.5em;
}

.ml-4 {
  margin-left: 1em;
}

.title {
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  color: #6d7587;

  margin-bottom: 30px;
}

.audience-subtitle {
  margin-top: 10px;
  font-weight: normal;
}

.form-section {
  margin-right: 160px;
  margin-bottom: 60px;
}

.form-item {
  margin: 12px 0;
}

.form-item-right-margin {
  margin-right: 30px;
}

.horizontal-items {
  display: flex;

  .delete-button {
    align-self: flex-end;
    margin-bottom: 25px;
    margin-left: 12px;
  }
}

.collapse {
  margin-bottom: 20px;
}

.item-group-title {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

.add-item-button {
  margin-top: 60px;
}

.add-section-button {
  margin-bottom: 80px;
}

.additional-section-actions {
  display: flex;
  justify-content: flex-end;

  > * {
    margin-left: 15px;
  }
}

.actions {
  width: 100%;
  margin-top: 100px;
  display: flex;
  justify-content: flex-end;
}
</style>

<script>
import {mapState, mapActions} from 'vuex';
import {required, requiredIf} from 'vuelidate/lib/validators';
import {omit, cloneDeep} from 'lodash';

import {updateProjectBrief, updateSharedProjectBrief} from '@/api/workflow';
import {cache} from '@/support/cache';

import ProjectScaffold from '../ProjectScaffold.vue';
import EditAdditionalSection from '../brief/EditAdditionalSection.vue';
import SupportingFilesUploader from '../brief/SupportingFileUploader.vue';
import AlertInfoBox from "@/components/widgets/AlertInfoBox.vue";
import AlertCommentBox from "@/components/widgets/AlertCommentBox.vue";

import projectViewHelpers from '@/mixins/projectViewHelpers';
import draggable from "vuedraggable";

function withSupportingFilesAsIds(container) {
  const {supportingFiles, ...rest} = container;
  return {
    ...rest,
    supportingFileIds: supportingFiles.map(file => file.id)
  };
}

export default {
  mixins: [projectViewHelpers],
  components: {
    ProjectScaffold,
    AlertCommentBox,
    AlertInfoBox,
    EditAdditionalSection,
    SupportingFilesUploader,
    draggable
  },
  data() {
    return {
      formData: [],
      b1: [
        {
          id: 1,
          type: 'textarea',
          title: 'BRAND & PRODUCT',
          label: '',
          placeholder: 'A brief description of the brand. (if possible, please add a presentation about brand values/guidelines). If the campaign is about a particular product / topic, please also includes a description of it (USP, Key message...)',
        },
        {
          id: 2,
          type: 'textarea',
          title: 'TARGET AUDIENCES',
          label: '',
          placeholder: 'Please describe your core target audiences',
        },
        {
          id: 3,
          type: 'textarea',
          title: 'CONTEXT',
          label: '',
          placeholder: 'In which context does the communication occur ? Is there any specific event to promote ? Is there a global promotion theme ? Do you have a specific offer ? Do you launch a new product ? Please be as precise as possible.',
        },
        {
          id: 4,
          type: 'textarea',
          title: 'MEDIA OBJECTIVES',
          label: '',
          placeholder: 'Please describe your objectives & KPI, with priority order. (Online sales, app downloads,accounts creation, Branding, awareness…)'
        },
        {
          id: 5,
          type: 'textarea',
          title: 'PLACEMENTS',
          label: '',
          placeholder: 'If you already know which formats you need, please advise.',
        },
        {
          id: 6,
          type: 'textarea',
          title: 'CREATIVE OBJECTIVES',
          label: '',
          placeholder: 'What’s your message? What do you want to convey? Again, please be as specific aspossible ',
        },
        {
          id: 7,
          type: 'textarea',
          title: 'MANDATORIES & GUILDELINES',
          label: '',
          placeholder: 'If you have any mandatories/details you want to share, please do it here. ex: “I want to display these 3 products in the creative”, “We have to include these legal mentions in every content”.'
        },
        {
          id: 8,
          type: 'textarea',
          title: 'PAST CAMPAIGNS',
          label: '',
          placeholder: 'Please share examples of your past campaigns, with what you want to highlight in terms of what worked / didn’t work and best practices you’ve learned. Feel free to add content references or benchmarks you like.',
        },
        {
          id: 9,
          type: 'textarea',
          title: 'EXISTING ASSETS',
          label: '',
          placeholder: 'Please provide as many as possible existing creative &amp; material.' + 'Assets should include the following:\n' +
              '- Logos / Fonts / Branding guidelines\n' +
              '- Assets that we can optimize, including images and videos, without text or logo on it.\n' +
              '- For assets with text on it or multiple elements, please get layered PSD/Ai/AE files\n' +
              '- Audio files (layered is always better in this case too meaning voices separated from the\n' +
              'music)*'
        }
      ],
      b2: [
        {
          id: 10,
          type: 'textarea',
          title: 'BRAND & PRODUCT',
          label: '',
          placeholder: 'A brief description of the brand. (if possible, please include your brand guidelines).If the campaign is about a particular product / topic, please also include a brief product description (the USPs, key messages...)'
        },
        {
          id: 11,
          type: 'textarea',
          title: 'TARGET AUDIENCES',
          label: '',
          placeholder: 'Please describe your core target audience(s)'
        },
        {
          id: 12,
          type: 'textarea',
          title: 'CONTEXT',
          label: '',
          placeholder: 'Do you have a specific offer ? Are there any specific events you would like to promote? Are you launching a new product ? Please be as precise as possible.'
        },
        {
          id: 13,
          type: 'textarea',
          title: 'MEDIA OBJECTIVES',
          label: '',
          placeholder: 'Please describe your objectives & KPI, with priority order. (Online sales, app downloads, accounts creation, Branding, awareness…)'
        },
        {
          id: 14,
          type: 'textarea',
          title: 'PLACEMENTS',
          label: '',
          placeholder: 'If you already know which formats you need, please advise.'
        },
        {
          id: 15,
          type: 'textarea',
          title: 'CREATIVE OBJECTIVES',
          label: '',
          placeholder: 'What’s your message? What do you want to convey? Again, please be as specific as possible '
        },
        {
          id: 16,
          type: 'textarea',
          title: 'MANDATORIES & GUILDELINES',
          label: '',
          placeholder: 'If you have any mandatories/details you want to share, please do it here. ex: “I want to display these 3 products in the creative”, “We have to include these legal mentions in every content”.'
        },
        {
          id: 17,
          type: 'textarea',
          title: 'EXISTING ASSETS',
          label: '',
          placeholder: 'Please provide as many as possible existing creative &amp; material.\n' +
              'Assets should include the following:\n' +
              '- Logos / Fonts / Branding guidelines\n' +
              '- Assets that we can optimize, including images and videos, without text or logo on it.\n' +
              '- For assets with text on it or multiple elements, please get layered PSD/Ai/AE files\n' +
              '- Audio files (layered is always better in this case too meaning voices separated from themusic)*'
        },
        {
          id: 18,
          type: 'textarea',
          title: 'PAST CAMPAIGNS',
          label: '',
          placeholder: 'Please share examples of your past campaigns, with what you want to highlight in terms of\n' +
              'what worked / didn’t work and best practices you’ve learned.\n' +
              'Feel free to add content references or benchmarks you like.'
        },
      ],
      loading: false,
      isEditing: false,
      message: null,
      briefSelected: 'b1',
      selectableBrief: [
        {name: 'Social ads', id: 'b1'},
        {name: 'Social ads / Original content', id: 'b2'},
        {name: 'Snap ads/story ads', id: 'b3'},
        {name: 'Teads atelier', id: 'b4'},
        {name: 'TikTok Original ads', id: 'b5'},
        {name: 'Covid 19 specific brief', id: 'b6'},
        {name: 'NGO', id: 'b7'},
        {name: 'Amazon creative days', id: 'b8'},
        {name: 'Creative exploration', id: 'b9'},
        {name: 'Social ads (Annual Brief) ', id: 'b10'},
        {name: 'Music ', id: 'b11'},
        {name: 'Pinterest creative', id: 'b12'},
        {name: 'Filter/Brand effect', id: 'b13'},
        {name: 'Tik Tok activation', id: 'b14'}
      ],
      form: {
        topic: {
          description: '',
          supportingFiles: []
        },
        objectives: {
          primaryObjective: {
            type: ''
          },
          secondaryObjective: {
            type: ''
          },
          supportingFiles: []
        },
        audiences: [],
        scope: {
          deliverables: '',
          languagesNeeded: '',
          supportingFiles: []
        },
        additionalSections: [],
        supportingFiles: [],
        specific: []
      }
    };
  },
  computed: {
    ...mapState('workflow', {
      currentProjectId: state => state.currentProjectId,
      currentProject: state => state.currentProject.value,
      brief: state => state.sharedResource.resource?.data,
      token: state => state.sharedResource.token,
      description: state => state.sharedResource.description,
      resource: state => state.sharedResource.resource,
      objectives: state => state.objectives.items
    }),
    ...mapState('workflow/brief', {
      loadingBrief: state => state.brief.loading,
      briefError: state => state.brief.error
    }),
    projectBrandNames() {
      return this.currentProject.brands.map(b => b.name).join(', ');
    },
    isViewable() {
      return this.brief && this.hasContent();
    },
    uploading() {
      return (
          this.form.topic.supportingFiles.filter(f => !f.createdAt).some(f => f.status && f.status !== 'success') ||
          this.form.audiences.some(audience =>
              audience.supportingFiles.filter(f => !f.createdAt).some(f => f.status && f.status !== 'success')
          ) ||
          this.form.scope.supportingFiles.filter(f => !f.createdAt).some(f => f.status && f.status !== 'success')
      );
    }
  },
  validations: {
    form: {
      topic: {
        description: {
          required
        }
      },
      objectives: {
        primaryObjective: {
          type: {
            required
          },
          value: {
            required: requiredIf(function () {
              return this.form.objectives.primaryObjective.type === 'other';
            })
          }
        },
        secondaryObjective: {
          type: {
            required
          },
          value: {
            required: requiredIf(function () {
              return this.form.objectives.secondaryObjective.type === 'other';
            })
          }
        }
      },
      audiences: {
        $each: {
          open: {},
          description: {
            required
          },
          problemSolved: {
            required
          },
          previousResults: {
            required
          },
          keyMessages: {
            required
          },
          thingToRecall: {
            required
          },
          proof: {
            required
          },
          callToAction: {
            required
          }
        }
      },
      scope: {
        deliverables: {
          required
        },
        languagesNeeded: {
          required
        }
      },
      additionalSections: {
        $each: {
          fields: {}
        }
      }
    }
  },
  methods: {
    ...mapActions('workflow', ['fetchProjectResource', 'updateSharedResourceData']),
    ...mapActions('workflow/brief', ['fetchCurrentProjectBrief', 'fetchCurrentProjectBriefPublic', 'refreshCurrentProjectBrief']),
    handleAddAudienceClick() {
      this.form.audiences.map(audience => (audience.open = false));
      this.form.audiences.push({
        open: true,
        description: '',
        problemSolved: '',
        previousResults: '',
        keyMessages: '',
        thingToRecall: '',
        proof: '',
        callToAction: '',
        supportingFiles: []
      });
    },
    handleAdditionalSectionEditClick(sectionIndex) {
      this.form.additionalSections.splice(sectionIndex, 1, {
        ...this.form.additionalSections[sectionIndex],
        updating: true
      });
    },
    hasContent() {
      return this.brief.validated || !this.isEmpty(this.brief, ['updatedAt', 'updatedBy', 'id', 'audiences']);
    },
    moveElement(id) {
      const index = this[this.briefSelected].findIndex(data => data.id === id);
      const element = this[this.briefSelected].splice(index, 1)[0];
      this[this.briefSelected].splice(index + 1, 0, element);
    },
    isEmpty(data, except = []) {
      if (!data) {
        return true;
      }

      if (typeof data === 'string') {
        return data.length == 0;
      }

      if (Array.isArray(data)) {
        return data.length == 0;
      }

      if (typeof data === 'object') {
        for (let key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key) && !except.includes(key)) {
            let value = data[key];
            if (!this.isEmpty(value)) return false;
          }
        }
      }

      return true;
    },
    handleAdditionalSectionRemoveClick(sectionIndex) {
      this.form.additionalSections = this.form.additionalSections.filter((_, i) => i !== sectionIndex);
    },
    handleAdditionalSectionChange(sectionIndex, value) {
      this.form.additionalSections.splice(sectionIndex, 1, {
        ...value,
        updating: false
      });
    },
    handleAddAdditionalSectionClick() {
      this.form.additionalSections = [
        ...this.form.additionalSections,
        {
          name: '',
          fields: [
            {
              name: '',
              value: ''
            }
          ],
          updating: true
        }
      ];
    },
    handleSubmit(shouldSubmit = false) {
      this.$v.$touch();
      this.loading = true;
      this.serialize();
      let dataBrief = []
      for (let data of this[this.briefSelected]) {
        data.value = this.formData[data.id];
        dataBrief.push(data);
      }
      updateProjectBrief({
        projectId: this.currentProject.id,
        brief: withSupportingFilesAsIds({
          ...this.form,
          topic: withSupportingFilesAsIds(this.form.topic),
          objectives: withSupportingFilesAsIds(this.form.objectives),
          audiences: this.form.audiences.map(withSupportingFilesAsIds),
          scope: withSupportingFilesAsIds(this.form.scope),
          specific: dataBrief,
          template: this.briefSelected,
          additionalSections: this.form.additionalSections.map(additionalSection =>
              omit(additionalSection, ['updating'])
          )
        })
      })
          .then(brief => {
            this.loading = false;
            this.clearDraft();
            this.isEditing = false;
            this.updateSharedResourceData(brief);
            if (shouldSubmit) {
              window.EventBus.$emit('download.pending', 'Your brief has been submitted to your producer !');
            } else {
              this.$router.push({name: 'projects.sharings', params: {token: this.token}});
            }
          })
          .catch(err => {
            console.error('Server error when updating project brief', err);
            this.showError('Error when updating project brief');
            this.loading = false;
          });

      // this.showError('You must fill in all required fields');
    },
    handleDeleteAudience(target) {
      this.form.audiences = this.form.audiences.filter((item, index) => index != target);
    },
    handleDeleteSecondaryObjective() {
      this.form.objectives.secondaryObjective = {
        type: ''
      };
    },
    serialize() {
      this.form.audiences.map(audience => delete audience.open);
    },
    unserialize(brief) {
      brief.audiences.map(audience => (audience.open = false));
      return brief;
    },
    getDraft(defaultValu) {
      const brief = cache(`brief.${defaultValu.id}`);

      return brief || defaultValu;
    },
    clearDraft() {
      cache().forget(`brief.${this.brief.id}`);
    },
    confirmExit(event = null) {
      return !this.isDirty() || this.shouldExitWithoutSaving(event);
    },
    shouldExitWithoutSaving(event = null) {
      const message = "WARNING - You haven't saved your brief. The information will be lost";

      if (event) {
        event.returnValue = message;
      }

      return event ? message : confirm(message);
    },
    saveDraft() {
      if (!this.isDirty()) return;

      cache(`brief.${this.brief.id}`, cloneDeep(this.form));
    },
    isDirty() {
      if (!this.isEditing) return false;

      let oldValu = JSON.stringify(this.unserialize(this.brief));
      let newValue = JSON.stringify(this.unserialize(this.form));

      if (oldValu !== newValue) {
        return true;
      }

      return false;
    },
    initForm(brief) {
      return this.unserialize(cloneDeep(brief));
    }
  },
  async mounted() {
    await this.fetchProjectResource({token: this.$route.params.token});
    await this.fetchCurrentProjectBriefPublic(this.currentProject.id);
    if (this.brief) {
      this.form = this.initForm(this.brief);
      if (this.brief.template) {
        this[this.brief.template] = this.brief.specific;
        for (const value of this.brief.specific) {
          this.formData[value.id] = value.value;
        }
        this.briefSelected = this.brief.template;
      }
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.confirmExit);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.confirmExit);
  },
  beforeRouteLeave(to, from, next) {
    !this.confirmExit() || next();
  },
  watch: {
    brief(value) {
      if (value) {
        this.form = this.initForm(value);
        if (!this.isViewable && sessionStorage.getItem('brief.empty') == null) {
          this.message = `You have been invited by your producer to fill out your <b>${this.currentProject.originalName}</b> Brief <br />For <b>${this.projectBrandNames}</b>. <br /> Please do so and submit once you're done`;
          window.EventBus.$emit('download.pending', this.message);
          sessionStorage.setItem('brief.empty', true);
        }
      }
    },
    form: {
      handler(val) {
        if (this.isEditing) return;

        this.isEditing = true;
      },
      deep: true
    },
    briefError(value) {
      if (value) {
        this.showError(value);
      }
    }
  }
};
</script>
